import { cn } from '@shadcn/lib/utils';

import psyomicsLogo from './assets/beseen_logo.svg';

type LogoProps = {
  readonly className?: string;
  readonly size?: 'sm' | 'md' | 'lg';
  readonly ariaLabel?: string;
};

const sizeClasses = {
  sm: 'h-6 w-auto',
  md: 'h-[34.873px] w-auto',
  lg: 'h-12 w-auto',
};

export function Logo({ className, size = 'md', ariaLabel = 'beseen Logo' }: LogoProps) {
  return <img alt={ariaLabel} className={cn(sizeClasses[size], className)} src={psyomicsLogo} />;
}
